var exports = {
  "iE": "xaee3c4fa--d4b047--wrapper",
  "$0": "xaee3c4fa--d4b047--title-wrapper",
  "DA": "xaee3c4fa--d4b047--similar-article-wrapper",
};

module.exports = exports;
